import { render } from "./GenKeyWarning.vue?vue&type=template&id=07bfe4ad"
import script from "./GenKeyWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./GenKeyWarning.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/GenKeyWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07bfe4ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07bfe4ad', __exports__)) {
    api.reload('07bfe4ad', __exports__)
  }
  
  module.hot.accept("./GenKeyWarning.vue?vue&type=template&id=07bfe4ad", () => {
    api.rerender('07bfe4ad', render)
  })

}


export default __exports__